export default class Account {
  loginName?: string;
  personId?: string;
  actionPersonId?: string;
  actions?: string[];
  email?: string;
  twoFactorAuthentication?: boolean
}
